// Re-exported from the shared person-display helpers so the roster's tiles share the
// exact name/initials/colour logic with the Competencies employee tiles.
export {
    NAVY,
    MUTED,
    fullName,
    hasName,
    initials,
} from '@/pages/Competencies/components/employees/personDisplay';

// 12 tiles per page in each section, paginated client-side (the roster endpoint
// returns the full array), matching the prototype.
export const ROSTER_PAGE_SIZE = 12;
